import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MessageSquareQuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llegué al día 7 sintiéndome diferente. No cambié todo, pero algo en mí se acomodó.',
    name: 'Alejandro',
    location: 'Argentina'
  }, {
    quote: 'El tracker me ayudó a no mentirme. Hice 6 de 7 días y me sentí más yo que en meses.',
    name: 'Cynthia',
    location: 'Peru'
  }, {
    quote: 'Lo que más me sorprendió fue el diagnóstico de autoestima. Me hizo ver cosas que venía evitando.',
    name: 'Jose',
    location: 'Mexico'
  }, {
    quote: 'Nunca pensé que 7 días podían hacer la diferencia. Pero no es magia: es sistema.',
    name: 'Liliana',
    location: 'USA'
  }];
  return <section id="testimonials" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-319">
      <div className="max-w-6xl mx-auto px-6" data-id="element-320">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-321">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-4" data-id="element-322">
            Prueba Social
          </h2>
          <p className="text-offwhite-dim text-lg" data-id="element-323">
            Resultados reales de personas reales.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-324">
          {testimonials.map((item, idx) => <FadeIn key={idx} delay={idx * 0.15} direction="up" className="bg-charcoal p-6 md:p-8 rounded-sm border border-charcoal-light relative" data-id="element-325">
              <MessageSquareQuoteIcon className="absolute top-6 right-6 w-8 h-8 text-sand/20" data-id="element-326" />
              <p className="text-base md:text-lg text-offwhite-dim italic leading-relaxed relative z-10" data-id="element-327">
                "{item.quote}"
              </p>
              <div className="mt-4 md:mt-6 flex items-center gap-3" data-id="element-328">
                <div className="w-10 h-10 bg-charcoal-dark rounded-full border border-charcoal-light flex items-center justify-center" data-id="element-329">
                  <span className="text-sand font-heading font-bold text-sm" data-id="element-330">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-331">
                  <span className="text-sm text-offwhite font-medium block" data-id="element-332">
                    {item.name}
                  </span>
                  <span className="text-xs text-offwhite-dim/60 uppercase tracking-wider" data-id="element-333">
                    {item.location}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}